export var NewSubscriptionStatus;
(function (NewSubscriptionStatus) {
    NewSubscriptionStatus["Created"] = "Created";
    NewSubscriptionStatus["Active"] = "Active";
    NewSubscriptionStatus["PastDue"] = "PastDue";
    NewSubscriptionStatus["Canceled"] = "Canceled";
})(NewSubscriptionStatus || (NewSubscriptionStatus = {}));
